// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"36262e79","453":"ee6c18de"}[chunkId] + ".chunk.js";
};